import actionTypes from '../constants/actionTypes'
import selectn from 'selectn'
import mapPageToTemplate from '../../reduxion-core/lib/mapPageToTemplate'
import { updateNavLinks } from './helpers'

export default function pageReducer( state = {}, action ) {

  let config
  let analytics
  let ads
  let params
  let edition
  let tier3Nav
  let tier2Nav
  let tier2NavLinks

  switch (action.type) {
    case actionTypes.UPDATE_TIMEZONE:

      config = {}
      config.edition = state.edition || {}
      config.edition.timeZoneBucket = action.edition.editionDateFormat.timeZoneBucket
      return Object.assign( {}, state, config )

    case actionTypes.PAGE_CONFIG:
      config = {}
      ads = action.ads || selectn('res.data.ads', action)
      analytics = action.analytics || selectn('res.data.analytics', action)
      tier3Nav = action.tier3Nav || selectn('res.data.tier3Nav', action)
      tier2Nav = action.tier2Nav || selectn('res.data.tier2Nav', action)
      tier2NavLinks = action.league || selectn('res.data.league', action)
      params = action.params || {}
      edition = action.edition

      if(ads) {
        config.ads = ads

        // If a previous value is available, preserve it unless we have new data
        let prevCMSEnabledSponsoredContentProviders = selectn('ads.cmsEnbldSpnsrdCntntPrvdrs', state)
        if(prevCMSEnabledSponsoredContentProviders) {
          config.ads.cmsEnbldSpnsrdCntntPrvdrs = config.ads.cmsEnbldSpnsrdCntntPrvdrs || prevCMSEnabledSponsoredContentProviders
        }
      }

      if(analytics) {
        config.analytics = analytics
      }

      if (process.browser && tier2Nav && tier2NavLinks) {
        updateNavLinks(tier2Nav, tier2NavLinks)
      }

      config.tier3Nav = tier3Nav
      config.tier2Nav = tier2Nav

      if(Object.keys(params).length > 0) {
        config.params = params
        config.template = mapPageToTemplate({ pageType: params.pageType, sport: params.sport })
      }

      config.edition = edition || state.edition

      return Object.assign({}, state, config)

    case actionTypes.APP_PROPS:
      var appProps = action.appProps || {}
      var deviceStr= appProps.device || ''

      appProps.device = deviceStr !== '' ? { [deviceStr] : true } : {}

      config = {}
      config.appProps = Object.assign({}, state.appProps, { ...appProps })

      return Object.assign( {}, state, config )

    case actionTypes.ALLOW_DENY_FASTCAST:
      var shouldAllow = action.payload || false
      return Object.assign( {}, state, {
        isFastcastAllowed : shouldAllow
      })

    default:
      return state

  }
}



// WEBPACK FOOTER //
// ../app/reducers/page.js